"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DomesticViolence = function DomesticViolence(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M13 15.5H17.9972C17.9983 15.5 17.9993 15.5 18.0004 15.5C18.0015 15.5 18.0029 15.5 18.0042 15.5H19C19.1326 15.5 19.2598 15.4473 19.3536 15.3536C19.4473 15.2598 19.5 15.1326 19.5 15V9C19.5 8.86739 19.4473 8.74021 19.3536 8.64645C19.2598 8.55268 19.1326 8.5 19 8.5H13C12.9835 8.5 12.9671 8.50089 12.9507 8.5025C12.9433 8.50322 12.936 8.50461 12.9287 8.50567C12.9199 8.50692 12.9111 8.50794 12.9023 8.50969C12.8936 8.51144 12.8857 8.51367 12.8775 8.51575C12.8699 8.51767 12.8624 8.51931 12.8549 8.52156C12.8468 8.52403 12.8389 8.52711 12.8309 8.52989C12.8235 8.53267 12.816 8.535 12.8087 8.53803C12.8014 8.54106 12.7941 8.54475 12.7868 8.54819C12.7795 8.55164 12.7717 8.55506 12.7644 8.559C12.7571 8.56294 12.7507 8.56703 12.7439 8.57111C12.7371 8.57519 12.7294 8.57944 12.7224 8.58414C12.7148 8.58922 12.7077 8.59486 12.7004 8.60036C12.6947 8.60467 12.6887 8.60869 12.6832 8.61322C12.6576 8.63417 12.6342 8.65757 12.6133 8.68308C12.6087 8.68864 12.6047 8.69464 12.6004 8.70042C12.5948 8.70767 12.5892 8.71478 12.5842 8.72233C12.5795 8.72942 12.5754 8.73678 12.571 8.74403C12.567 8.75075 12.5627 8.75733 12.5591 8.76428C12.5551 8.77175 12.5517 8.77942 12.5481 8.78706C12.5447 8.79419 12.5412 8.80125 12.5381 8.80858C12.5351 8.81592 12.5326 8.82367 12.5298 8.83122C12.527 8.83878 12.524 8.84678 12.5215 8.85478C12.5189 8.86278 12.5175 8.87008 12.5155 8.87775C12.5135 8.88589 12.5112 8.89392 12.5096 8.90219C12.5078 8.91119 12.5068 8.92028 12.5054 8.92933C12.5044 8.93639 12.5031 8.94322 12.5024 8.95053C12.5007 8.96703 12.4999 8.98355 12.4999 9.00008V15C12.4999 15.0657 12.5128 15.1307 12.538 15.1914C12.5631 15.252 12.5999 15.3072 12.6464 15.3536C12.6928 15.4 12.748 15.4369 12.8086 15.462C12.8693 15.4871 12.9343 15.5 13 15.5ZM18.5 9.5V11.691L17.7488 12.0667L18.3904 9.5H18.5ZM18.309 14.5L17.6708 13.2236L18.5 12.809V14.5H18.309ZM13.5 14.5V10.2071L16.2929 13L14.7929 14.5H13.5ZM16.863 13.8441L17.191 14.5H16.2071L16.863 13.8441ZM16.7291 12.022L14.2071 9.5H17.3596L16.7291 12.022Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9 15.5H7C6.86739 15.5 6.74021 15.5527 6.64645 15.6464C6.55268 15.7402 6.5 15.8674 6.5 16C6.5 16.1326 6.55268 16.2598 6.64645 16.3536C6.74021 16.4473 6.86739 16.5 7 16.5H9C9.13261 16.5 9.25979 16.4473 9.35355 16.3536C9.44732 16.2598 9.5 16.1326 9.5 16C9.5 15.8674 9.44732 15.7402 9.35355 15.6464C9.25979 15.5527 9.13261 15.5 9 15.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M11.5 9C11.5 8.86739 11.4473 8.74021 11.3536 8.64645C11.2598 8.55268 11.1326 8.5 11 8.5H5C4.86739 8.5 4.74021 8.55268 4.64645 8.64645C4.55268 8.74021 4.5 8.86739 4.5 9V20.5286H0V21.5286H24V20.5286H11.5V9ZM5.5 9.5H10.5V20.5286H5.5V9.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M9.5 13C9.77614 13 10 12.7761 10 12.5C10 12.2239 9.77614 12 9.5 12C9.22386 12 9 12.2239 9 12.5C9 12.7761 9.22386 13 9.5 13Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M24 2.5H0V3.5H24V2.5Z",
    fill: props.foregroundColor
  })), _react.default.createElement("defs", null, _react.default.createElement("clipPath", {
    id: "clip0"
  }, _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};

DomesticViolence.defaultProps = {
  altText: "DomesticViolence",
  backgroundColor: "#00D2D2",
  foregroundColor: "#000000"
};
DomesticViolence.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = DomesticViolence;
exports.default = _default;